import {UIController} from "../UIController";
import {SVGComponent} from "@webfruits/toolbox/dist/components/svg/SVGComponent";
import {CoreAssets} from "../../core/CoreAssets";
import {UIComponent} from "@webfruits/core";

/******************************************************************
 * NewsletterController
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class NewsletterController extends UIController {

    /******************************************************************
     * Properties
     *****************************************************************/

    private readonly _submitButton: HTMLButtonElement
    private readonly _form: HTMLFormElement
    private readonly _actionURL: string

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(rootElement: HTMLElement) {
        super(rootElement);
        this._submitButton = this.getElementByClass("kkt-newsletter-submit-button") as HTMLButtonElement;
        this._form = this.getElementByClass("kkt-newsletter-form") as HTMLFormElement;
        this._actionURL = this._form.dataset.actionUrl;
        this.initListeners()
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private initListeners(): void {
        this._submitButton.addEventListener("click", e => {
            if (!this._form.checkValidity()) return
            e.preventDefault()
            this.sendData()
        });
    }

    private async sendData() {
        this.removeErrorMessages()
        this._submitButton.disabled = true;
        const formData = new FormData(this._form);

        const response = await fetch(this._actionURL, {
            method: 'POST',
            body: formData
        })
        const result = await response.json();
        if (response.status == 200 && result.success) {
            this._form.reset();
            this._submitButton.disabled = false;
            this.showSuccessModal({message: this.view.dataset.successMessage})
            return
        }
        this.showErrorMessages(result.errors)
    }

    private showErrorMessages(errors: Object) {
        Object.keys(errors).forEach(key => {
            const inputElement = this._form.querySelector(`[data-type="${key}"]`) as HTMLDivElement;
            if (!inputElement) return;
            const errorElement = document.createElement("div");
            errorElement.className = "kkt-newsletter-input-error-message";
            errorElement.innerHTML = errors[key];
            inputElement.appendChild(errorElement);
        })
    }

    private removeErrorMessages() {
        this.getElementsByClass("kkt-newsletter-input-error-message").forEach(errorElement => {
            errorElement.remove();
        })
    }

    private showSuccessModal(args: { url?: string, message?: string }) {
        const dialog = new UIComponent<HTMLDialogElement>("dialog")
        dialog.view.className = "kkt-newsletter-modal";
        const closeButton = new SVGComponent(CoreAssets.CLOSE_BUTTON);
        closeButton.view.className = "kkt-newsletter-modal-close-button";
        closeButton.addNativeListener("click", () => {
            dialog.destroy();
        })
        dialog.addChild(closeButton);
        dialog.view.show()
        if (args.url) {
            const iFrame = new UIComponent<HTMLIFrameElement>("iframe");
            iFrame.view.src = args.url;
            iFrame.view.className = "kkt-newsletter-modal-iframe";
            dialog.addChild(iFrame);
        }
        if (args.message) {
            const message = new UIComponent();
            message.view.innerHTML = args.message;
            message.view.className = "kkt-newsletter-modal-success-message";
            dialog.addChild(message);
        }
        this.addChild(dialog);
    }

}
